<template>
  <div>
    <div class="title">
      <div>
        <!-- eslint-disable-next-line vue/no-mutating-props -->
        <el-date-picker v-if="timeRange2 ? timeRange2[0] ? true : false : false" v-model="timeRange2" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :clearable="false" @change="timeChange"></el-date-picker>
        <!-- eslint-disable-next-line vue/no-mutating-props -->
        <el-date-picker v-else-if="timeRange3 ? timeRange3[0] ? true : false : false" v-model="timeRange3" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :clearable="false" @change="timeChange"></el-date-picker>
        <!-- eslint-disable-next-line vue/no-mutating-props -->
        <el-date-picker v-else-if="timeRange5 ? timeRange5[0] ? true : false : false" v-model="timeRange5" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :clearable="false" @change="timeChange"></el-date-picker>
        <!-- eslint-disable-next-line vue/no-mutating-props -->
        <el-date-picker v-else-if="timeRange4 ? timeRange4[0] ? true : false : false" v-model="timeRange4" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :clearable="false" @change="timeChange"></el-date-picker>
        <el-input v-show="isHideSearch" v-model="searchInput" placeholder="请输入分类名称" suffix-icon="el-icon-search" style="margin-left:20px;width:220px;" @blur="searchChange" @keyup.enter="searchChange"></el-input>
      </div>
      <div>
        <el-button type="primary" @click="download">导出报表</el-button>
        <el-button type="primary" @click="onPrint">打印报表</el-button>
      </div>
    </div>
    <br />
    <el-table v-if="update" ref="otherTable" v-loading="loading" tooltip-effect="light" :data="data" style="width: 100%" @sort-change="otherSortChange">
      <el-table-column v-for="(item,index) in array" :key="index" :prop="item.prop" :sortable="item.name == '员工名称' ? false : true">
        <template slot="header" slot-scope="scope">
          <span v-show="scope">{{ item.name }}</span>
          <el-popover placement="top-start" width="200" trigger="hover" :content="item.tip">
            <i v-show="item.showTip" slot="reference" class="el-icon-info"></i>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column v-if="isShowConfig" label="操作">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="onCheckDetail(scope)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

export default {
  props: {
    array: {
      type: Array,
      default: Array
    },
    data: {
      type: Array,
      default: Array
    },
    timeRange2: {
      type: Array,
      default: Array
    },
    timeRange3: {
      type: Array,
      default: Array
    },
    timeRange4: {
      type: Array,
      default: Array
    },
    timeRange5: {
      type: Array,
      default: Array
    },
    changeTabs: {
      type: Boolean
    },
    isShowConfig: {
      type: Boolean
    },
    isHideSearch: {
      type: Boolean
    },
    loading: {
      type: Boolean
    }
  },
  data() {
    return {
      searchInput: '',
      update: true,
      // expireTimeOption: {
      //   disabledDate(date) {
      //     return date.getTime() > Date.now();
      //   }
      // }
    };
  },
  watch: {
    changeTabs(val) {
      this.timeChange(val);
      this.searchChange('');
    }
  },
  methods: {
    clearSort() {
      this.$refs.otherTable.clearSort();
      this.update = false;
      this.$nextTick(() => {
        this.update = true;
      });
    },
    // 6.7排序
    otherSortChange({ prop, order }) {
      this.$emit('sortChange', { prop, order });
    },
    timeChange(val) {
      this.$emit('timeChange', val);
    },
    searchChange() {
      this.$emit('searchChange', this.searchInput);
    },
    onCheckDetail(scope) {
      this.$emit('onCheckDetail', scope);
    },
    download() {
      this.$emit('ondownload', '');
    },
    onPrint() {
      this.$emit('onPrint', '');
    }
  }
};
</script>

<style lang="less" scoped>
.title,
.title > div {
  display: flex;
}
.title {
  justify-content: space-between;
}
</style>
